var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('van-icon',{staticClass:"arrow_left",attrs:{"name":"arrow-left"},on:{"click":_vm.goBack}}),_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }